module.exports = __webpack_public_path__ + "static/media/download.e95c82fa.svg";